<div class="box-breadcrumb" [ngClass]="'theme-' + theme">
    <nz-breadcrumb [nzSeparator]="separator">
        <!-- Home breadcrumb -->
        <nz-breadcrumb-item *ngIf="showHome">
            <a (click)="goToHome($event)">
                {{ 'breadcrumb.home' | translate }}
            </a>
        </nz-breadcrumb-item>

        <!-- Dynamic breadcrumb items -->
        <nz-breadcrumb-item *ngFor="let item of items; let last = last">
            <!-- Clickable item with routerLink -->
            <a
                *ngIf="isClickable(item) && item.path && !item.onClick"
                (click)="goToPath(item.path)">
                {{ item.label | translate }}
            </a>

            <!-- Clickable item with onClick handler -->
            <a
                *ngIf="isClickable(item) && item.onClick"
                (click)="onItemClick(item, $event)"
                style="cursor: pointer;">
                {{ item.label | translate }}
            </a>

            <!-- Active/current item (not clickable) -->
            <span *ngIf="!isClickable(item)">
                {{ item.label | translate }}
            </span>
        </nz-breadcrumb-item>
    </nz-breadcrumb>
</div>
